import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monleys NAS Synology',
    title: 'I. Préparation et planification',
    titleKey: 'auditCyber.timeline.services.1.title',
    description: 'Définition du périmètre de l\'audit, incluant les systèmes, applications et infrastructures concernés. ',
    descriptionKey: 'auditCyber.timeline.services.1.description',
    link: '/#',
    features: [
      { text: '' },
      { text: "Atelier de lancement avec les parties prenantes" },
      { text: 'Définition du périmètre technique et organisationnel' },
      { text: 'Identification des actifs et des scénarios de risque à évaluer' },
      { text: 'Validation du planning et des règles d\'engagement' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'II. Collecte d\'informations',
    titleKey: 'auditCyber.timeline.services.2.title',
    description: 'Identification des surfaces d\'attaque potentielles et d\'anticiper les vulnérabilités exploitables par un attaquant.',
    descriptionKey: 'auditCyber.timeline.services.2.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Renseignement par sources ouvertes' },
      { text: 'Revue documentaire des politiques et procédures' },
      { text: 'Entretiens ciblés avec les collaborateurs clés' },
      { text: 'Analyse des vulnérabilités techniques et humaines' },
      { text: 'Cartographie de la surface d\'attaque externe et interne' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'III. Exploitation des vulnérabilités',
    titleKey: 'auditCyber.timeline.services.3.title',
    description: 'Identification et exploitation des vulnérabilités présentes afin d\'évaluer le niveau réel de sécurité de l\'organisation.',
    descriptionKey: 'auditCyber.timeline.services.3.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Tentatives d\'exploitation des vulnérabilités découvertes' },
      { text: 'Tests de pénétration externes (depuis Internet) et internes' },
      { text: 'Scénarios de tests d\'ingénierie sociale' },
      { text: 'Évaluation de la robustesse des mécanismes de détection et de réponse' },
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'IV. Rapport d\'audit',
    titleKey: 'auditCyber.timeline.services.4.title',
    description: 'Rapport détaillé présentant les résultats de l\'audit, les vulnérabilités détectées et les remédiations.',
    descriptionKey: 'auditCyber.timeline.services.4.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Rédaction d\'une synthèse managériale claire et concise' },
      { text: 'Description détaillée de chaque faille (criticité, preuve, impact)' },
      { text: 'Feuille de route de remédiation priorisée' },
      { text: 'Atelier de restitution pour présenter les résultats et répondre aux questions' },
    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'V. Suivi post-audit',
    titleKey: 'auditCyber.timeline.services.5.title',
    description: 'Assistance pour les corrections, suivi et vérification de leur efficacité.',
    descriptionKey: 'auditCyber.timeline.services.5.description',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Support post-audit pour clarifier les recommandations' },
      { text: 'Aide à la planification de la remédiation' },
      { text: 'Possibilité de réaliser un contre-audit pour valider les corrections' },
      { text: 'Accompagnement vers une démarche d\'amélioration continue de la sécurité' },
    ],
  },
];
